import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  Container,
  Card,
  CardContent,
} from '@mui/material';
import {
  CloudUpload as CloudUploadIcon,
  VideoLibrary as VideoLibraryIcon,
} from '@mui/icons-material';
import { getLocationOn, Colors } from '../../../helpers/navigationHelpers';
import styles from './CreateReel.module.css';

const CreateReel = () => {
  const [locationOn, setLocationOn] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    setLocationOn(getLocationOn());
  }, []);

  const primaryColor = locationOn ? Colors.CUSTOM_YELLOW : Colors.PRIMARY;

  const handleFileSelect = () => {
    // File selection logic will go here
    alert('File selection functionality will be implemented');
  };

  const handleSubmit = () => {
    // Submit logic will go here
    alert('Reel creation functionality will be implemented');
  };

  return (
    <Container maxWidth="md" className={styles.container}>
      {/* Header */}
      <Box className={styles.header}>
        <VideoLibraryIcon sx={{ fontSize: 48, color: primaryColor, marginBottom: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom>
          Create Reel
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Share your moments with the community
        </Typography>
      </Box>

      {/* Upload Section */}
      <Paper elevation={2} className={styles.uploadSection}>
        <Box
          className={styles.uploadArea}
          onClick={handleFileSelect}
          sx={{
            borderColor: primaryColor,
            '&:hover': {
              backgroundColor: 'rgba(0, 84, 153, 0.04)',
            },
          }}
        >
          <CloudUploadIcon sx={{ fontSize: 64, color: primaryColor }} />
          <Typography variant="h6" gutterBottom>
            Upload Media
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Click to select photos or videos
          </Typography>
          <Button
            variant="contained"
            startIcon={<CloudUploadIcon />}
            sx={{
              marginTop: 2,
              backgroundColor: primaryColor,
              '&:hover': {
                backgroundColor: primaryColor,
                opacity: 0.8,
              },
            }}
          >
            Select Files
          </Button>
        </Box>
      </Paper>

      {/* Form Section */}
      <Card className={styles.formSection}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Reel Details
          </Typography>
          
          <TextField
            fullWidth
            label="Title"
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            margin="normal"
            sx={{
              '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                borderColor: primaryColor,
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: primaryColor,
              },
            }}
          />

          <TextField
            fullWidth
            label="Description (Optional)"
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            margin="normal"
            multiline
            rows={4}
            sx={{
              '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                borderColor: primaryColor,
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: primaryColor,
              },
            }}
          />

          <Box className={styles.actionButtons}>
            <Button
              variant="outlined"
              sx={{
                borderColor: primaryColor,
                color: primaryColor,
                '&:hover': {
                  borderColor: primaryColor,
                  backgroundColor: 'rgba(0, 84, 153, 0.04)',
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              sx={{
                backgroundColor: primaryColor,
                '&:hover': {
                  backgroundColor: primaryColor,
                  opacity: 0.8,
                },
              }}
            >
              Post Reel
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Info Section */}
      <Card className={styles.infoSection}>
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            <strong>Tips:</strong>
          </Typography>
          <ul>
            <li>
              <Typography variant="body2" color="text.secondary">
                Videos should be less than 1 minute
              </Typography>
            </li>
            <li>
              <Typography variant="body2" color="text.secondary">
                Use vertical (9:16) format for best results
              </Typography>
            </li>
            <li>
              <Typography variant="body2" color="text.secondary">
                Add a catchy title to get more views
              </Typography>
            </li>
          </ul>
        </CardContent>
      </Card>
    </Container>
  );
};

export default CreateReel;

















